var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M18.21.571 1.876 16.906.572 23.429l6.522-1.305L23.43 5.79zM15.6 5.268l2.61-2.61 3.13 3.132-2.608 2.61zM3.234 17.634 14.558 6.31l3.13 3.131L6.367 20.765l-3.913.782z",
  clipRule: "evenodd"
})));
export default SvgPencil;